// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import '@/assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'
import router from './router'


import Vant from 'vant';



import VueCropper from 'vue-cropper' 
import 'babel-polyfill'
import 'vant/lib/index.css';
import '@/assets/style/common.css'

Vue.use(VueCropper)
Vue.use(ElementUI);
Vue.use(Vant);


Vue.config.productionTip = false
// 引入 axios 文件
import api from '@/assets/axios_api/index.js'
// 绑定 axios 到全局（vue对象原型方法）
Vue.prototype.$api = api





;
Vue.prototype.$getRsaCode = function(pubKey,str){ // 注册方法
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str);  // 进行加密
  return data;
}

//接口路径配置
import globalPath from '@/assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

// import VueResource from 'vue-resource' //使用的json数据
// Vue.use(VueResource)

// import * as filters from '@/assets/script/filters.js'
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })
/* eslint-disable no-new */
window.Vue =new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js